import React, { useEffect, useRef, useState } from "react";
import BuilderModal from "../../../Layouts/Modal/BuilderModal";
import PageInfoAndActionBar from "../../../Layouts/PageInfoAndActionBar";
import { useAppBlocksContext } from "../../../context/AppBlocksContext";
import { useTableContext } from "../../../context/TableContext";
import Calendar from "./../../../images/Calendar.png";
import "./Calender.css";
import EditCalendar from "./EditCalendar/EditCalendar";
import AccessTemplateSelection from "../../../components/BuilderComponents/AccessTemplateSelection";
import NotesAndTags from "../../../components/BuilderComponents/NotesAndTags";
import Button from "../../../components/FormComponents/Button";

const CalenderRenderer = ({ applicationBlockData, handleSaveApplicationBlock, handleCloneApplicationBlock }) => {
  const { currentBlockConfig, setApplicationBlockData } = useAppBlocksContext();
  const { getSingleTableData } = useTableContext();
  const [isEditBarOpen, setIsEditBarOpen] = useState(false);
  const [currentSmLookup, setCurrentSmLookup] = useState([]);
  const tableRef = useRef();
  const [showNotesModal, setShowNotesModal] = useState(false);
  const [showOwnerModal, setShowOwnerModal] = useState(false);

  const handleNotesAndTag = (data, keyName) => {
    const copyBlockData = JSON.parse(JSON.stringify(applicationBlockData));
    copyBlockData[keyName] = data;
    setApplicationBlockData(copyBlockData);
  };

  const handleAccessTemplate = (data) => {
    const copyBlockData = JSON.parse(JSON.stringify(applicationBlockData));
    copyBlockData.access_templates = data;
    setApplicationBlockData(copyBlockData);
    setShowOwnerModal(false);
  };

  useEffect(() => {
    let { data, tableObject } = getSingleTableData(currentBlockConfig.table_id);
    const allActivities = data.table.columns_new.filter((col) => col.type === "activity");
    const lookups = {};
    for (let act of allActivities) {
      for (let field of act.items) {
        if (field.field_type === "lookup") {
          lookups[field.id] = field;
        }
      }
    }
    tableRef.current = tableObject;
    setCurrentSmLookup(lookups);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <PageInfoAndActionBar
        pagePath={`Calender/${applicationBlockData.name}`}
        clonePage={handleCloneApplicationBlock}
        savePage={handleSaveApplicationBlock}
        currentConfig={[currentBlockConfig, applicationBlockData]}
        pageName="applicationblock"
        notesPage={() => setShowNotesModal(!showNotesModal)}
        saveOwner={() => setShowOwnerModal(!showOwnerModal)}
      />
      <div className="page_main_section">
        <div className="claender_View_outer">
          <img className="w_100" src={Calendar} alt="Calendar" />
          <div className="overlay_cover"></div>
          <div className="calenderView_edit_btn">
            <Button onClick={() => setIsEditBarOpen(true)}>Edit Calender</Button>
          </div>
        </div>
        <BuilderModal isOpen={showNotesModal} onClose={() => setShowNotesModal(false)} modalName="Notes and Tags">
          <NotesAndTags
            notesValue={applicationBlockData.description || ""}
            tagValue={applicationBlockData.info_tag || []}
            onChange={handleNotesAndTag}
          />
        </BuilderModal>
        {isEditBarOpen && (
          <EditCalendar
            tableRef={tableRef}
            setIsEditBarOpen={setIsEditBarOpen}
            currentSmLookup={currentSmLookup}
            tableId={currentBlockConfig.table_id}
            tableType={"statemachine"}
          />
        )}
        <BuilderModal
          isOpen={showOwnerModal}
          onClose={() => setShowOwnerModal(false)}
          modalName="Select Access Templates"
        >
          <AccessTemplateSelection
            templates={applicationBlockData.access_templates}
            handleChange={handleAccessTemplate}
          />
        </BuilderModal>
      </div>
    </div>
  );
};

export default CalenderRenderer;
